<template>
  <q-card class="auth-card">
    <q-card-main>
      <!-- Success message -->
      <div v-if="requestSuccessful" class="success">
        <check-mark></check-mark>
        <h4 class="text-center">{{ $t('reset_success_title') }}</h4>
        <p class="text-center">{{ $t('reset_success_body') }}</p>
      </div>

      <template v-else>
        <h1 class="text-center auth-card__heading">{{ $t('reset_heading') }}</h1>
        <p class="text-center auth-card__description">{{ $t('reset_description') }}</p>

        <form id="reset-form" @submit.prevent="handleReset">
          <!-- Password -->
          <q-field :error="errors.has('password')" :error-label="errors.first('password')">
            <q-input
              name="password"
              v-model="password"
              v-validate.disable="'required|min:8'"
              type="password"
              :float-label="$t('password')"
              required
              autofocus/>
          </q-field>

          <div class="auth-card__footer row justify-between">
            <div class="col-md-auto col-xs-12 self-center auth-card__secondary-action">
              <router-link :to="{ name: 'login' }" class="router-link">{{ $t('goto_login') }}</router-link>
            </div>

            <div class="col-md-auto col-xs-12 self-center auth-card__primary-action" v-if="!requestSuccessful">
              <q-btn type="submit" color="primary">{{ $t('reset') }}</q-btn>
            </div>
          </div>
        </form>
      </template>
    </q-card-main>
  </q-card>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { UserClient } from 'src/api/Users'
  import { createErrorFromResponse } from 'src/utils/error'
  import { debounce } from 'quasar'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    props: {
      token: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        password: '',
        requestSuccessful: false
      }
    },

    methods: {
      handleReset: debounce(function () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.reset()
          })
      }, 500, true),

      reset () {
        new UserClient().resetPassword(this.$route.query.email, this.password, this.token)
          .then(() => {
            this.requestSuccessful = true
          })
          .then(() => {
            setTimeout(() => {
              this.$router.push({ name: 'login' })
            }, 5000)
          })
          .catch(createErrorFromResponse)
      },

      handleToLogin () {
        this.$router.replace({ name: 'login' })
      }
    },

    components: {
      CheckMark
    }
  }
</script>
